import { Link } from 'react-router-dom';
import LegalDoc from '../components/LegalDoc';
import {
  CONTACT_VK,
  OPERATOR_EMAIL,
  OPERATOR_INN,
  OPERATOR_NAME,
  OPERATOR_OGRNIP,
  OPERATOR_PHONE,
  POLICY_DATE,
  SITES_LABEL,
  TERMS_PATH,
} from '../legal/operator';

export default function OfertaPage() {
  return (
    <LegalDoc title="Договор-оферта">
      <p>
        Настоящий документ — публичная оферта на занятия с репетитором.
        Доступ к сайту {SITES_LABEL} регулируется{' '}
        <Link to={TERMS_PATH}>пользовательским соглашением</Link>
        {' '}и может быть бесплатным. Эта оферта применяется, когда родитель
        принимает её отдельной отметкой и ученик занимается с репетитором.
        Редакция: {POLICY_DATE}
      </p>

      <h2>Кто заключает договор</h2>
      <p>
        Договор с репетитором заключает родитель (законный представитель) ученика.
        Акцепт — регистрация или вход по ссылке-приглашению и отдельная отметка
        «Принимаю договор-оферту».
      </p>
      <p>
        Регистрация ученика 14 лет и старше открывает доступ к Сайту по
        пользовательскому соглашению и сопровождается согласием ученика на
        обработку его персональных данных. Эта регистрация не является
        заключением договора на занятия.
      </p>
      <p>
        Ученик младше 14 лет сам не регистрируется. Родитель регистрируется,
        принимает пользовательское соглашение для аккаунта ребёнка, даёт согласие
        на его данные и отправляет ссылку. По этой ссылке ребёнок создаёт аккаунт.
        Договор на занятия при этом заключает родитель.
      </p>

      <h2>Предмет</h2>
      <p>
        Репетитор Власенко Борис Анатольевич оказывает услуги по обучению ученика.
        Договор заключает и оплату производит родитель ученика.
      </p>
      <p>
        Обучение дистанционное: голосовая связь через Яндекс Телемост или
        «Макс»; совместная работа на Сайте (задания, редактор кода, журнал
        занятий). При необходимости стороны могут дополнительно использовать
        программу удалённого доступа.
      </p>
      <p>
        На занятии репетитор объясняет материал, проверяет домашние задания,
        отвечает на вопросы ученика.
      </p>

      <h2>Права и обязанности сторон</h2>
      <p>
        Ученик обязан предоставить достоверные сведения о себе и обеспечить
        техническую возможность проводить занятия.
      </p>
      <p>Для занятий потребуется:</p>
      <ul>
        <li>компьютер, ноутбук или планшет, на котором можно работать с Сайтом;</li>
        <li>устойчивый интернет от 2 Мбит/с;</li>
        <li>аккаунт в «Макс» или ВКонтакте для связи;</li>
        <li>микрофон, разборчиво передающий речь;</li>
        <li>веб-камера не нужна;</li>
        <li>
          низкий уровень слышимых на занятии шумов (важна не сама обстановка,
          а то, что попадает в микрофон).
        </li>
      </ul>
      <p>
        Если рабочее место ученика не соответствует этим требованиям, репетитор
        вправе приостановить занятия до устранения помех.
      </p>
      <p>
        Ученик обязан выполнять домашние задания. Ученик и родители обязаны
        сообщать достоверные сведения. Ученик пользуется одним аккаунтом.
        Запрещено создавать несколько аккаунтов или иным способом влиять на
        подсчёт решённых задач и времени работы.
      </p>
      <p>
        Репетитор обязан поддерживать в рабочем состоянии Сайт с тестирующей
        системой и личным кабинетом. При сбое — восстановить работу в кратчайший
        срок.
      </p>
      <p>
        Стороны придерживаются графика занятий и заранее сообщают об отменах.
      </p>
      <p>
        Ученик вправе записывать занятия (видео, аудио) без уведомления репетитора,
        только для личного просмотра. Выкладывать запись в открытый доступ или
        передавать посторонним без письменного согласия репетитора нельзя.
        Родственникам ученика — можно.
      </p>
      <p>
        На занятии можно есть и пить (чай, яблоки, печенье и т.п.), если это не
        мешает работе.
      </p>
      <p>
        После занятия ученик и репетитор заполняют карточку занятия в журнале на
        Сайте.
      </p>
      <p>
        Репетитор следует целям обучения и вправе менять запланированную тему,
        если того требует ситуация.
      </p>
      <p>
        Родители вправе следить за успехами ученика по журналу на Сайте и
        обращаться к репетитору (в порядке приоритета):
      </p>
      <ul>
        <li>
          ВКонтакте:{' '}
          <a href={CONTACT_VK} target="_blank" rel="noopener noreferrer">
            vk.com/boris_vlasenko
          </a>{' '}
          (основной способ);
        </li>
        <li>
          почта:{' '}
          <a href={`mailto:${OPERATOR_EMAIL}`}>{OPERATOR_EMAIL}</a>
        </li>
        <li>телефон / SMS: {OPERATOR_PHONE}</li>
      </ul>
      <p>
        Споры стороны сначала пытаются урегулировать без суда.
      </p>

      <h2>Опоздания и технические проблемы</h2>
      <p>Если опоздал ученик, репетитор может:</p>
      <ul>
        <li>по согласованию провести занятие полной длительности (закончить позже);</li>
        <li>
          по согласованию уменьшить длительность и оплату (не более чем на 50%);
        </li>
        <li>
          уменьшить длительность, не уменьшая оплату, если ученик не предупредил и
          причина неуважительная.
        </li>
      </ul>
      <p>
        Нет на занятии без предупреждения 15 минут и дольше — репетитор вправе
        отменить занятие. Пропуск без предупреждения по неуважительной причине —
        вправе списать полную стоимость занятия.
      </p>
      <p>
        Если опоздал репетитор, стороны могут по согласованию либо закончить позже,
        либо уменьшить стоимость пропорционально. Три опоздания репетитора без
        уважительной причины и предупреждения на 5 минут и более дают ученику право
        на один час занятия без оплаты.
      </p>
      <p>
        Краткий сбой на стороне ученика: время окончания можно сдвинуть, чтобы
        сохранить длительность. Краткий сбой на стороне репетитора: закончить позже
        или уменьшить стоимость пропорционально.
      </p>

      <h2>Ответственность</h2>
      <p>
        Репетитор отвечает за соответствие темы целям обучения и за актуальность
        заданий, но не за результат экзамена.
      </p>

      <h2>Расчёты</h2>
      <p>
        Первое занятие (кроме разовой консультации) оплачивается после проведения и
        подтверждает заключение договора. Если первое занятие не понравилось — оно
        не оплачивается, договор не считается заключённым.
      </p>
      <p>
        Оплата — через платёжную систему на Сайте (Озон Пай) после регистрации.
        Предоплаты суммируются на семейном счёте в личном кабинете. Зачисление
        после подтверждения платежа.
      </p>
      <p>
        После занятия с баланса списывается стоимость занятия. Занятие проводится
        при достаточной предоплате, кроме оговорённого выше первого занятия.
      </p>

      <h2>Срок действия и расторжение</h2>
      <p>
        Договор бессрочный. Ученик может отказаться от занятий в любой момент без
        объяснения причин. Репетитор — если ученик неоднократно мешает обучению.
        Договор считается расторгнутым, если ученик с нулевым балансом пропустил
        два занятия подряд.
      </p>
      <p>
        Предоплата за непроведённые занятия возвращается полностью за вычетом
        комиссий платёжных систем и банков (и при переводе репетитору, и при
        возврате).
      </p>

      <h2>Реквизиты</h2>
      <ul>
        <li>Наименование: {OPERATOR_NAME}</li>
        <li>ОГРНИП: {OPERATOR_OGRNIP}</li>
        <li>ИНН: {OPERATOR_INN}</li>
        <li>
          email:{' '}
          <a href={`mailto:${OPERATOR_EMAIL}`}>{OPERATOR_EMAIL}</a>
        </li>
        <li>телефон: {OPERATOR_PHONE}</li>
        <li>
          ВКонтакте:{' '}
          <a href={CONTACT_VK} target="_blank" rel="noopener noreferrer">
            vk.com/boris_vlasenko
          </a>
        </li>
      </ul>
    </LegalDoc>
  );
}
